function handleIntersectObserver(entries: IntersectionObserverEntry[]): void {
  // Get first entry
  const entry = entries[0];

  // If we scrolled past element return
  if (entry.boundingClientRect.top < 0) return;

  // Set classlist of element to stuck if it's original location is in view
  entry.target.classList.toggle('vacature-contact--unstuck', entry.intersectionRatio >= 1);
}

// Get contact bar
const vacatureContactWrapper = document.querySelector('.vacature-contact');

// Define observer options
const observerOptions = {
  rootMargin: '0px 0px -54px 0px',
  threshold: [1],
};
// Create observer
const observer = new IntersectionObserver(handleIntersectObserver, observerOptions);

// If contact bar exists, observe it
if (vacatureContactWrapper) {
  observer.observe(vacatureContactWrapper);
}

function addVacatureName(
  name: string,
  element: HTMLInputElement = document.querySelector('.vacature-form-identifier input'),
): void {
  element.value = name;
}
window.addVacatureName = addVacatureName;
